const styles = theme => ({
    grow: {
        flexGrow: 1,
    },
    root: {
        minHeight: "calc(100vh - 68px)",
        position: 'relative',
        overflow: 'hidden',
        [theme.breakpoints.down('md')]: {
            minHeight: 'calc(100vh - 65px)',
        },
        [theme.breakpoints.down('sm')]: {
            minHeight: 'calc(100vh - 60px)',
        },
        '&::before': {
            content: '""',
            position: 'fixed',
            inset: 0,
            pointerEvents: 'none',
            background: 'none',
            zIndex: 0,
        },
        '& > *': {
            position: 'relative',
            zIndex: 1,
        },
    },
});

export default styles;
